import React from 'react';

const teamMembers = [
  {
    id: 1,
    name: "Jagarlapudi Ravi Kanth",
    role: "Host & Founder · SaiAcuity · Hyderabad",
    image: "https://customer-assets.emergentagent.com/job_751d7503-a1f9-4307-b026-754ff698f3bd/artifacts/boe9w03v_Ravi%20Prof%20Pic.png",
    bio: "Ravi Kanth is the Founder of SaiAcuity and the Host of the Monday Morning Learning Podcast. He brings over 25 years of experience in learning, leadership development, and people strategy, built across HSBC and Wells Fargo, where he led learning transformation initiatives across global service centres in Asia, India, and the Philippines. In 2017, he stepped out of the corporate world to build something he could not do from the inside: listen more carefully and share more freely. He is the author of The Third Listening and The Inner Architecture, two books distilled from over 60 conversations with leaders across industries. He holds a Master's degree from the Sri Sathya Sai Institute of Higher Learning and an Executive Development credential from XLRI."
  },
  {
    id: 2,
    name: "Pankaj Rai",
    role: "Group CDAO · Aditya Birla Group · Bangalore",
    image: "https://customer-assets.emergentagent.com/job_751d7503-a1f9-4307-b026-754ff698f3bd/artifacts/yt1rswx6_Pankaj%20Rai.jpg",
    bio: "Pankaj Rai brings a career spanning over three decades across management consulting, financial services, technology, and analytics. He is currently the Group Chief Data and Analytics Officer at Aditya Birla Group, leading the analytics maturity journey through data science, horizontal data platforms, and people capability development. His prior roles include SVP Strategy at Wells Fargo, Director of Analytics at Dell across nearly eleven years, and credit and portfolio leadership roles at GE Capital. He holds a B.Tech from IIT Delhi, an MBA from IIM Ahmedabad, and a Diploma from the London School of Economics."
  },
  {
    id: 3,
    name: "Shubhayu Sengupta",
    role: "Chief People Officer · Zeta · Bangalore",
    image: "https://customer-assets.emergentagent.com/job_751d7503-a1f9-4307-b026-754ff698f3bd/artifacts/oui60v7z_Shubhayu.jpg",
    bio: "Shubhayu Sengupta is a seasoned HR leader with over 27 years of experience across global financial institutions, consulting, and the GCC and IT/ITeS sectors. He is currently Chief People Officer at Zeta, a founder-driven banking technology company transforming the payments and credit space globally. His prior roles span Swiss Re, Wells Fargo, EY GBS, HGS Hinduja Global Solutions, and Sagility. He began his career at PwC in the Organisation Change and Strategy Group. His concept of Informed Audacity and his articulation of the psychological contract have made him one of the podcast's most quoted voices across Season 1 and Season 2. He holds a PMIR from XLRI Jamshedpur."
  },
  {
    id: 4,
    name: "Nidhi Pratapneni",
    role: "GCC Leader · AI & Analytics Strategist · Singapore",
    image: "https://customer-assets.emergentagent.com/job_751d7503-a1f9-4307-b026-754ff698f3bd/artifacts/dd8d7r6l_Nidhi.jpg",
    bio: "Nidhi Pratapneni is a senior leader with over 25 years of experience across analytics, AI, brand and communications, DEI, and talent strategy. Recognised as one of the Top 100 AI Leaders in India by AIM (2022). Her career spans McKinsey and Co., Safeway, Dell, dunnhumby, Antuit, and Wells Fargo, where she served as SVP and Site Leader for Bangalore. She holds an MBA in Marketing from IIM Calcutta and a B.A. (Honours) in Economics from St. Stephen's College, Delhi."
  },
  {
    id: 5,
    name: "Subramani Balakrishnan",
    role: "CXO Coach & Founder · Forpple Consulting · Mumbai",
    image: "https://customer-assets.emergentagent.com/job_751d7503-a1f9-4307-b026-754ff698f3bd/artifacts/m29gqmql_Subramani.jfif",
    bio: "Subramani Balakrishnan is a Professional Certified Coach (PCC, ICF) and the Founder of Forpple Consulting, where he has worked with CEOs, CXOs, and senior leaders for over a decade as a trusted thinking partner. He holds the EMCC EIA-SP and ACTC credentials. His coaching is anchored in his 3A framework: Aspire, Act, Accept, drawing from adult development theory, Transactional Analysis, and systems thinking. He holds an MBA in Finance from the Sri Sathya Sai Institute of Higher Learning and an Engineering degree from Malaviya National Institute of Technology, Jaipur."
  }
];

const About = () => {
  return (
    <div className="min-h-screen pt-24 pb-20 bg-dark-bg">
      {/* Page Header */}
      <section className="py-16 md:py-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-gold text-xs font-medium uppercase tracking-[0.3em] mb-4">
            The People Behind It
          </p>
          <h1 className="font-playfair text-4xl md:text-5xl lg:text-6xl font-medium text-warm-white tracking-tight">
            The MMLP Team
          </h1>
        </div>
      </section>

      {/* Team Members */}
      <section className="pb-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-16 md:space-y-24">
            {teamMembers.map((member, index) => (
              <div 
                key={member.id} 
                className={`flex flex-col md:flex-row gap-8 md:gap-12 items-start ${
                  index % 2 === 1 ? 'md:flex-row-reverse' : ''
                }`}
              >
                {/* Photo */}
                <div className="flex-shrink-0">
                  <div className="w-40 h-40 bg-dark-card border border-dark-border flex items-center justify-center">
                    <img 
                      src={member.image} 
                      alt={member.name}
                      className="w-full h-full object-contain"
                    />
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1">
                  <h2 className="font-playfair text-2xl md:text-3xl font-medium text-warm-white mb-2">
                    {member.name}
                  </h2>
                  <p className="text-gold text-xs font-medium uppercase tracking-[0.2em] mb-6">
                    {member.role}
                  </p>
                  <p className="text-warm-white/60 leading-relaxed">
                    {member.bio}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="border-t border-dark-border"></div>
      </div>

      {/* Closing Statement */}
      <section className="py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="font-playfair text-xl md:text-2xl text-warm-white/70 italic leading-relaxed">
            "Every conversation is a chance to learn something you didn't know you needed."
          </p>
          <p className="text-gold text-xs font-medium uppercase tracking-[0.2em] mt-6">
            — The MMLP Philosophy
          </p>
        </div>
      </section>
    </div>
  );
};

export default About;
